import React, { useEffect } from "react";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import AOS from "aos";
import 'aos/dist/aos.css';
import HomePage from "./components/HomePage";
import AboutPage from "./components/AboutPage";
import ContactPage from "./components/ContactPage";
import ProductPage from "./components/ProductPage";
import SafetyTips from "./components/SafetyTips";
function App() {

  useEffect(() => {
    AOS.init({
      duration: 1200, // duration of animations in milliseconds
    });
  }, []);

  return (
    <Router>
      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/about" element={<AboutPage />} />
        <Route path="/product" element={<ProductPage />} />
        <Route path="/safety" element={<SafetyTips />} />
        <Route path="/contact" element={<ContactPage />} />
      </Routes>
    </Router>

  );
}

export default App;
